module.exports = __webpack_public_path__ + "img/media-6.59356d84.png";